import * as types from './types';

const getItemNames = (searchParams) => ({
  type: types.GET_ITEM_NAMES,
  data: searchParams,
});

const setItemNames = (itemNames) => ({
  type: types.SET_ITEM_NAMES,
  data: itemNames,
});

const getItemCategories = (searchParams) => ({
  type: types.GET_ITEM_CATEGORIES,
  data: searchParams,
});

const setItemCategories = (itemCategories) => ({
  type: types.SET_ITEM_CATEGORIES,
  data: itemCategories,
});

const getStates = (searchParams) => ({
  type: types.GET_STATES,
  data: searchParams,
});

const setStates = (states) => ({
  type: types.SET_STATES,
  data: states,
});

const getLicenseNumbers = (searchParams) => ({
  type: types.GET_LICENSE_NUMBERS,
  data: searchParams,
});

const setLicenseNumbers = (licenseNumbers) => ({
  type: types.SET_LICENSE_NUMBERS,
  data: licenseNumbers,
});

const getQuantityTypes = (searchParams) => ({
  type: types.GET_QUANTITY_TYPES,
  data: searchParams,
});

const setQuantityTypes = (quantityTypes) => ({
  type: types.SET_QUANTITY_TYPES,
  data: quantityTypes,
});

const getPackageIds = (searchParams) => ({
  type: types.GET_PACKAGE_IDS,
  data: searchParams,
});

const setPackageIds = (packageIds) => ({
  type: types.SET_PACKAGE_IDS,
  data: packageIds,
});

export {
  getItemNames,
  setItemNames,
  getItemCategories,
  setItemCategories,
  getStates,
  setStates,
  getLicenseNumbers,
  setLicenseNumbers,
  getQuantityTypes,
  setQuantityTypes,
  getPackageIds,
  setPackageIds,
};
